// pages/auth/ForgotPasswordPage.tsx
import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Card, CardContent, CardFooter } from "../ui/card"
import { Button } from '../ui/button';
import { authAPI } from "../../services/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      await authAPI.forgotPassword(email);  // Axios handles errors internally
      setSent(true);
    } catch (err: any) {
      const msg = err?.response?.data?.message || 'Une erreur est survenue.';
      setError(msg);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-accent py-12 px-4 sm:px-6 lg:px-8 dark:bg-gray-900">
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center justify-center text-center">
          <h1 className="mt-6 text-3xl font-serif font-bold tracking-tight">Mot de passe oublié</h1>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            Mettez votre email et un lien de vérification sera envoyé à votre email, veuillez cliquer dessus pour changer votre mot de passe
          </p>
        </div>

        <Card>
            <CardContent className="pt-6">
                {sent ? (
                    <p className="text-green-600">
                    Un lien de réinitialisation a été envoyé à votre adresse e-mail.
                    </p>
                ) : (
                    <form onSubmit={handleSubmit}>
                    <Input
                        type="email"
                        placeholder="Votre email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    {error && <p className="text-red-600 text-sm mt-2">{error}</p>}
                    <Button type="submit" className="mt-4 w-full">Envoyer le lien</Button>
                    </form>
                )}
            </CardContent>
            <CardFooter className="flex flex-col space-y-4">
                <p className="mt-4 text-center text-sm text-gray-500 dark:text-gray-400">
                    Retour à{" "}
                    <a href="/signin" className="font-medium text-elille-blue hover:underline">
                    la connexion
                    </a>
                </p>
            </CardFooter>
        </Card>
      </div>
    </div>
  );
}
